module.exports = __webpack_public_path__ + "img/wheel_LOW_lose.d5e5bf77.png";